module.exports = __webpack_public_path__ + "img/rezakhanloug.8fef09d0.jpg";